(()=>{
    // Adapted from https://dev.to/ananyaneogi/create-a-dark-light-mode-switch-with-css-variables-34l8
    document.addEventListener("DOMContentLoaded", function() {
        const toggleSwitch = document.querySelector('.theme-switch input[type="checkbox"]');
        const currentTheme = localStorage.getItem("theme");
        if (currentTheme) {
            document.documentElement.setAttribute("data-theme", currentTheme);
            toggleSwitch.checked = currentTheme === "dark";
        }
        function switchTheme(e) {
            if (e.target.checked) {
                document.documentElement.setAttribute("data-theme", "dark");
                localStorage.setItem("theme", "dark");
            } else {
                document.documentElement.setAttribute("data-theme", "light");
                localStorage.setItem("theme", "light");
            }
        }
        toggleSwitch.addEventListener("change", switchTheme, false);
    });
})();

//# sourceMappingURL=index.bac1d36c.js.map
